<template>
  <manifest />
</template>

<script>
import Manifest from "@/components/3pl/Operations/consolidation-new/manifest";

export default {
  components: {
    Manifest,
  },
};
</script>

<style></style>